import React, { useState } from "react";
import { useMenuAuthInfo } from "../../services/GlobalUtil";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import api from "../../services/api";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import InputWrapDiv from "../../components/common/InputWrapDiv";
import TopBoxDiv from "../../components/common/TopBoxDiv";
import ContentInput from "../../components/common/ContentInput";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import MessageDialog from "../../components/common/MessageDialog";

const ApplicationAddFilePage = () => {
  const menuAuthInfo = useMenuAuthInfo();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");

  const [appFileDesc, setFileDescription] = useState("");
  const [file, setFile] = useState(null);

  const handleFileDescChange = (e) => {
    setFileDescription(e.target.value.trim());
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = () => {
    const applicationFile = {
      appFileDesc,
      createId: JSON.parse(sessionStorage.getItem("userInfo"))?.userId || "",
    };

    const formData = new FormData();

    formData.append(
      "applicationFile",
      new Blob([JSON.stringify(applicationFile)], { type: "application/json" })
    );
    if (file) formData.append("file", file);

    api
      .post("/manage/application/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((response) => {
        if (response.data === 0) {
          setDialogMessage("L0103");
          setDialogOpen(true);
        } else if (response.data === 1301) {
          setDialogMessage("L0764");
          setDialogOpen(true);
        } else {
          setDialogMessage("L0459");
          setDialogOpen(true);
        }
      })
      .catch((error) => {
        console.error("Error upload file:", error);
      });
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("MENU:L0056"), t("MENU:L0288")]} />

      <InputWrapDiv>
        <TopBoxDiv value={t("L1091")} />

        <table>
          <tr>
            <th>{t("L0245")}</th>
            <td>
              <ContentInput type="file" onChange={handleFileChange} />
            </td>
          </tr>
          <tr>
            <th>{t("L0143")}</th>
            <td>
              <ContentInput
                value={appFileDesc}
                maxLength={500}
                onChange={handleFileDescChange}
                disabled={!menuAuthInfo.edit}
              />
            </td>
          </tr>
        </table>
      </InputWrapDiv>

      <ButtonWrapDiv className="btn_bottom">
        {menuAuthInfo.edit && (
          <FunctionButton
            className="big"
            value={t("L0659")}
            onClick={handleSubmit}
          />
        )}
        <FunctionButton
          className="big bg_gray"
          value={t("L0005")}
          onClick={handleCancel}
        />
      </ButtonWrapDiv>

      {dialogOpen && (
        <MessageDialog title={t("L0339")} message={t(dialogMessage)}>
          {dialogMessage === "L0103" ? (
            <FunctionButton
              value={t("L0004")}
              onClick={() => {
                setDialogOpen(false);
                navigate("/manage/application");
              }}
            />
          ) : (
            <FunctionButton
              value={t("L0004")}
              onClick={() => {
                setDialogOpen(false);
              }}
            />
          )}
        </MessageDialog>
      )}
    </div>
  );
};

export default ApplicationAddFilePage;
